// extracted by mini-css-extract-plugin
export var wrapperStyle = "video_with_device_frame-module--wrapperStyle--okROq";